import { 
    createContext, 
    useState 
} from "react";

export const DrawerContext = createContext({})

export function ContextDrawerProvider({ children }) {
    const [showInnerCamera, setShowInnerCamera] = useState(false);
    const [showInnerVideo, setShowInnerVideo] = useState(false);
    const [showMenuOrdering, setShowMenuOrdering] = useState(false);
    const [showUploadVideo, setShowUploadVideo] = useState(false);
    const [videoAnuncio, setVideoAnuncio] = useState('');
    const [showMenuOrderingRegional, setShowMenuOrderingRegional] = useState(false);
    const [showMenuOrderingEstados, setShowMenuOrderingEstados] = useState(false);
    const [showMenuOrderingEstadosByRegional, setShowMenuOrderingEstadosByRegional] = useState(false);
    const [idEstado, setIdEstado] = useState('');

    function handleCloseMenuOrderingRegional() {
        setShowMenuOrderingRegional(false);
    }

    function handleCloseMenuOrderingEstadosByRegional() {
        setShowMenuOrderingEstadosByRegional(false);
    }

    function handleCloseMenuOrderingContainer() {
        setShowMenuOrdering(false);
    }

    function handleCloseMenuOrderingEstados() {
        setShowMenuOrderingEstados(false);
    }

    return (
        <DrawerContext.Provider value={{
            setShowInnerCamera,
            showInnerCamera,
            setShowInnerVideo,
            showInnerVideo,
            setShowMenuOrdering,
            showMenuOrdering,
            showUploadVideo,
            setShowUploadVideo,
            videoAnuncio,
            setVideoAnuncio,
            showMenuOrderingRegional,
            setShowMenuOrderingRegional,
            handleCloseMenuOrderingRegional,
            showMenuOrderingEstados,
            setShowMenuOrderingEstados,
            handleCloseMenuOrderingEstados,
            handleCloseMenuOrderingContainer,
            idEstado,
            setIdEstado,
            showMenuOrderingEstadosByRegional,
            setShowMenuOrderingEstadosByRegional,
            handleCloseMenuOrderingEstadosByRegional
        }}>
            { children }
        </DrawerContext.Provider>
    )
}